import { Component, computed, inject } from '@angular/core';
import { PageNotFound404Component } from 'declarabid-library';
import { LibraryTextsTranslationsService } from '../../../core/services/library-texts-translations.service';

@Component({
  selector: 'app-page-not-found',
  imports: [PageNotFound404Component],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
  private readonly _libraryTextsTranslationsService = inject(
    LibraryTextsTranslationsService,
  );

  readonly notFoundPageTexts = computed(() =>
    this._libraryTextsTranslationsService.notFoundPageTexts(),
  );
}
